import { navigateTo, useRoute } from '#imports'
import { type Ref, computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Insight } from '~/api/insights/types'

import { TAB_HOME } from '../Insights.constants'
import translations from '../Insights.translations'

export function useTabs(insights: Ref<Insight[]>) {
  const i18n = useI18n()
  const route = useRoute()

  const tabs = computed(() => [
    {
      label: i18n(translations.tabHome),
      name: TAB_HOME,
    },
    ...insights.value,
  ])

  const currentTab = computed(() => route.query.tableau as string)

  function getTabLink(tabName: string) {
    return { ...route, query: { tableau: tabName } }
  }

  async function goToTab(tabName: string) {
    const tabLink = getTabLink(tabName)
    void navigateTo(tabLink)
  }

  return { tabs, currentTab, goToTab, getTabLink }
}
